@if (communicationService.user.config?.actionCenter.visible && reload) {
  <div [ngClass]="['xfw3-grid-row-container']" divBreakpointClass>
    <div class="xfw3-grid-row-fr">
      <app-action-group [src]="'action'" [widgetId]="'action'"/>
    </div>
  </div>
}
